import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minussquareo",
  "use": "minussquareo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"minussquareo\"><title>minussquareo</title><path d=\"M13.875 2.125v11.766H2.125V2.125h11.75zm0-1.125H2.125q-.469 0-.797.328T1 2.125v11.766q0 .453.328.789t.797.336h11.766q.453 0 .789-.336t.336-.789V2.125q0-.469-.336-.797T13.875 1zm-2.437 7.578H4.532q-.219 0-.391-.164t-.172-.398q0-.234.172-.398t.391-.164h6.906q.219 0 .391.164t.172.398q0 .234-.172.398t-.391.164z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/minussquareo.svg
// module id = 477
// module chunks = 0